import * as Immutable from 'immutable';
import globalLogger from '../../../logger/logger';

const logger = globalLogger.createChannel('workspace.onboarding');

const EMPTY_STEP = Immutable.Map();

let onboardingSteps;

export const preloadOnboardingSteps = () =>
    import(/* webpackChunkName: "onboarding-content" */ './onboardingStepsConfig').then((loadedSteps) => {
        onboardingSteps = loadedSteps.default;
    });

export default (stepId) => {
    if (!onboardingSteps) {
        logger.warn('Trying to load onboarding step but config not loaded yet', { stepId });
        return EMPTY_STEP;
    }

    return onboardingSteps.get(stepId);
};
